/**
 * Efekt dialogów kontaktowych
 * 
 *  "speech" Standardowy dymek dialogowy. Najczęściej używany. { spec: { style: 'speech' }}
 *  "thought" Dymek myśli, składający się z "chmurek". { spec: { style: 'thought' } }
 *  "pointedArcs" Dymek krzyku. Tworzy kształt z "kolcami".Be ogonka  { spec: { style: 'pointedArcs', points: 12 } }
 *   "caption" Dymek narracyjny. Prostokątny, często używany do opisów sceny. Bez ogonka. 	{ spec: { style: 'caption' } }
 *  "rectangle" 	Zwykły prostokąt. Podobny do caption, ale bardziej generyczny. Bez ogonka. { spec: { style: 'rectangle' } }
 *  "none" 	Brak widocznego dymka. Używane, gdy chcesz mieć sam tekst. Bez ogonka. { spec: { style: 'none' } }
 */

export function initComicsDialogs() {
  const allParentElements = Array.from(document.querySelectorAll('.subsection[id^="section6"]'));
  if (allParentElements.length === 0) return;

  // --- FUNKCJE POMOCNICZE ---
  function getBreakpoint() {
    const width = window.innerWidth;
    if (width < 768) return 'mobile';
    if (width < 1024) return 'tablet';
    return 'desktop';
  }
  function parseCoords(str) {
    if (!str) return null;
    const parts = str.split(',').map(s => parseFloat(s.trim()));
    if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) return { x: parts[0], y: parts[1] };
    return null;
  }

  // --- GŁÓWNA FUNKCJA RYSOWANIA ---
  function configureAndDrawAllComics() {
    const breakpoint = getBreakpoint();
    // console.log(`🎨 Rysowanie komiksu dla widoku: ${breakpoint}`);

    // 1️⃣ Ustaw pozycje CSS dymków
    const allBubbles = document.querySelectorAll('.dialogue[id^="bubble"]');
    allBubbles.forEach(bubbleEl => {
      const breakpointKey = `pos${breakpoint.charAt(0).toUpperCase() + breakpoint.slice(1)}`;
      let posStr = bubbleEl.dataset[breakpointKey] || bubbleEl.dataset.posDesktop;
      if (posStr) bubbleEl.style.cssText = posStr;
    });

    // 2️⃣ Etap 1: Konfiguracja dymków-rodziców
    allBubbles.forEach(bubbleEl => {
      if (bubbleEl.dataset.parentId) return; // pomijamy dzieci

      const style = bubbleEl.dataset.specStyle || 'speech';
      const bubble = new Bubble(bubbleEl);
      const spec = Bubble.getDefaultBubbleSpec(bubbleEl, style);
      spec.level = parseInt(bubbleEl.dataset.specLevel, 10) || spec.level;

      if (bubbleEl.dataset.colorBg) {
        spec.backgroundColors = [bubbleEl.dataset.colorBg];
      }

      if (style === 'speech' || style === 'thought') {
        const breakpointKey = `tailTo${breakpoint.charAt(0).toUpperCase() + breakpoint.slice(1)}`;
        let coordsStr = bubbleEl.dataset[breakpointKey] || bubbleEl.dataset.tailToDesktop;
        if (coordsStr) {
          const coords = parseCoords(coordsStr);
          if (coords && spec.tails[0]) {
            spec.tails[0].tipX = coords.x;
            spec.tails[0].tipY = coords.y;
          }
        }
      }

      bubble.setBubbleSpec(spec);
    });

    // 3️⃣ Etap 2: Rysowanie i relacje
    Comical.startEditing(allParentElements);

    allBubbles.forEach(bubbleEl => {
      if (bubbleEl.dataset.parentId) {
        const parentBubbleEl = document.getElementById(bubbleEl.dataset.parentId);
        if (parentBubbleEl) Comical.initializeChild(bubbleEl, parentBubbleEl);
      }
    });

    allParentElements.forEach(parent => Comical.update(parent));
    Comical.stopEditing();
  }

  // --- ANIMACJE WIDOCZNOŚCI ---
  function setupVisibilityAnimations() {
    document.querySelectorAll('.dialogue, .comical-generated').forEach(el => el.classList.add('is-hidden'));

    allParentElements.forEach(parent => {
      const svgShape = parent.querySelector('.comical-generated');
      const bubblesInSection = Array.from(parent.querySelectorAll('.dialogue'));
      if (!svgShape) return;

      const elementsToAnimate = [svgShape, ...bubblesInSection];
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => svgShape.classList.remove('is-hidden'), 100);
            bubblesInSection.forEach(bubbleEl => {
              const delay = parseInt(bubbleEl.dataset.delay, 10) || 200;
              setTimeout(() => bubbleEl.classList.remove('is-hidden'), delay);
            });
          } else {
            elementsToAnimate.forEach(el => el.classList.add('is-hidden'));
          }
        });
      }, { threshold: 0.3 });

      observer.observe(parent);
    });
  }

  // --- DEBOUNCE (opóźnianie rysowania przy resize) ---
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }

  // --- URUCHOMIENIE GŁÓWNE ---
  configureAndDrawAllComics();
  setupVisibilityAnimations();

  const debouncedRedraw = debounce(configureAndDrawAllComics, 250);
  window.addEventListener('resize', debouncedRedraw);
}
